import { twMerge } from 'tailwind-merge'

type ClassValue = string | undefined | null | false

/** Joins class names and resolves conflicting Tailwind utilities. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(inputs.filter(Boolean).join(' '))
}
